import { Box, xcss } from '@atlaskit/primitives';
import React, { FunctionComponent } from 'react';

const outerBoxStyles = xcss({
  borderBottomWidth: '2px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'color.border',
});

const innerBoxStyles = xcss({
  padding: 'space.100',
  marginLeft: 'space.negative.200',
});

type StyledBoxWrapperProps = {
  children: React.ReactNode;
  showBorder?: boolean;
};

const StyledBoxWrapper: FunctionComponent<StyledBoxWrapperProps> = ({
  children,
  showBorder,
}) => {
  return (
    <Box xcss={[showBorder && outerBoxStyles]}>
      <Box xcss={innerBoxStyles}>{children}</Box>
    </Box>
  );
};

export default StyledBoxWrapper;
